import React from "react";
import { Link } from "react-router-dom";


export function TopBar({ active = "grid" }) {
return (
<div className="top-bar">
<Link to="/admin/add-new-company" className="btn btn-turquoise">
<i className="fa-solid fa-plus"></i> Add New Company
</Link>
<div>
<Link to="/admin/company-card-view-list" className={active === "cards" ? "actives me-3" : "me-3"}>
<i className="fa-solid fa-bars fa-lg"></i>
</Link>
<Link to="/admin/company-list" className={active === "grid" ? "actives me-3" : "me-3"}>
<i className="fa-solid fa-th-large fa-lg"></i>
</Link>
</div>
</div>
);
}